// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36u4o","expireSoon":"styles_expireSoon__KRdH6"};